import { Selectors as Router } from 'router';
import { Selectors as Campaigns } from 'sections/campaigns/state/campaigns';
import { Selectors as Rulesets } from 'sections/campaigns/state/rulesets';
import { State } from 'store';

const getRulesetIds = (state: State): string[] => {
  const campaignId = Router.getCampaignId(state);
  const campaign = Campaigns.getUpdatedEntity(state, campaignId);
  const priorities = (!!campaign && campaign.rulesetPriorities) || [];

  const allRulesets =
    Rulesets.getUpdatedEntityIds(state, {
      filters: [x => x.campaignId === campaignId],
    }) || [];
  const deletedRulesets = state.campaigns.editor.rulesetsToDelete || [];

  return [
    ...priorities.filter(id => allRulesets.indexOf(id) > -1),
    ...allRulesets.filter(id => priorities.indexOf(id) === -1),
  ].filter(id => deletedRulesets.indexOf(id) === -1);
};

const getDeletedRulesetIds = (state: State): string[] => state.campaigns.editor.rulesetsToDelete;

export const Selectors = {
  getRulesetIds,
  getDeletedRulesetIds,
};
